export const deleteCertificate = ({BeURL ,id}) => {
    fetch(`${BeURL}/candidate-certificate-delete/${id}`, {
        method: "DELETE",
        credentials: 'include'
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                alert(data.message)
                window.location.reload()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error to Delete candidate certificate", err)
        })
}
